import { HttpErrorResponse } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { GridComponent } from "@syncfusion/ej2-angular-grids";
import {
  DataStateChangeEventArgs,
  FilterSettingsModel,
} from "@syncfusion/ej2-grids";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GlobalComponent } from "src/app/global/global.component";

import {
  DynamicFormTemplateBo,
  functionpermission,
  saveTemplateBo,
  LovBO
} from "./dynamicformtemplate.modal";

import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DynamicFormTemplateService } from "./dynamicformtemplate.service";
import { ColumnChangeBO, columnWidth } from "../employee/employee.model";
import { CommonHttpService } from "src/app/common.service";

@Component({
  selector: "app-dynamicformtemplate-template",
  templateUrl: "./dynamicformtemplate.component.html",
  styleUrls: ["./dynamicformtemplate.component.scss"],
})
export class DynamicFormTemplateComponent implements OnInit {
  dynamicFormTemplateType: any = [];
  saveBo: saveTemplateBo = new saveTemplateBo();
  @ViewChild("gridDynamicFormTemplate")
  public gridDynamicFormTemplate: GridComponent;
  private onDestroy$: Subject<void> = new Subject<void>();
  Lov: LovBO = new LovBO();
  GetDynamicFormTemplateList: DynamicFormTemplateBo =
    new DynamicFormTemplateBo();
  id: number = 0;
  @ViewChild('fileInput') fileInput: ElementRef;

  dynamicFormTemplateId: string = "";
  entityTypeCode: string;
  name: string;
  ColumnArray: columnWidth[];
  filterOptions: FilterSettingsModel;
  FileURl: any;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  selectedFormFields: any = [];
  FormFieldList: any = [];
  initialPage: object;
  type: string;
  arraycol: any = [];
  DynamicFormTemplateDataDictionary: any = [];
  templateName: string = "";
  isSaveorUpdateBoolean:boolean=false;
  FilterselectedType: string = "";
  FilterGroupType: string = "";
  TemplateFile: File = null;
  validatingFile: boolean = false;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public GridDataList: Observable<DataStateChangeEventArgs>;
  DynamicTemplateId: any;
  fp: functionpermission;
  listId: any;
  GroupNameList: any = [];
  constructor(
    public global: GlobalComponent,
    public DFTS: DynamicFormTemplateService,
    public toasterService: ToastrService, public formBuilder: FormBuilder,
    public CommonAPI: CommonHttpService,
  ) {

    this.GridDataList = this.DFTS;
  }

  ngOnInit(): void {
    this.fp = new functionpermission();

    this.dynamicFormTemplateType = [
      {
        id: "SESSION",
        typeName: "SESSION",
      },
      {
        id: "CLIENT",
        typeName: "CLIENT",
      },
      {
        id: "EMPLOYEE",
        typeName: "EMPLOYEE",
      }
    ];
    // this.saveBo.entityTypeCode = this.dynamicFormTemplateType.filter(
    //   (s) => s.typeName == "SESSION"
    // )[0].id;

    // this.FilterselectedType = this.dynamicFormTemplateType.filter(
    //   (s) => s.typeName == "SESSION"
    // )[0].id;


    if (this.global.userID == "00000000-0000-0000-0000-000000000000" || this.global.userID == null || this.global.userID == undefined) {

      if (this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000" || this.global.globalAgencyId == null || this.global.globalAgencyId == undefined) {

        this.dynamicFormTemplateType = [
          {
            id: "SESSION",
            typeName: "SESSION",
          },
          {
            id: "CLIENT",
            typeName: "CLIENT",
          },
          {
            id: "EMPLOYEE",
            typeName: "EMPLOYEE",
          }
        ];

      } else {
        this.dynamicFormTemplateType = this.dynamicFormTemplateType.filter(
          (s) => s.typeName != "SESSION"
        );
      }


    }
    else {
      this.dynamicFormTemplateType = this.dynamicFormTemplateType.filter(
        (s) => s.typeName != "SESSION"
      );
    }
    let JsonPage;

    // JsonPage = JSON.parse(this.global.globalColumn.column)[0]
    //   .Dynamic_Form_Template.Pagesize;
    this.filterOptions = { type: "Menu" };
    // this.initialPage = {
    //   currentPage: 1,
    //   totalRecordsCount: 0,
    //   pageCount: JsonPage,
    //   pageSize: JsonPage,
    //   pageSizes: this.pageSizes,
    // };
    this.initialPage = {
      pageSizes: ["10", "20", "50", "100", "250"],
      pageSize: 10,
    };
    if (JsonPage != null) {
      this.GetDynamicFormTemplateList.pageitem = JsonPage;
    } else {
      this.GetDynamicFormTemplateList.pageitem = 10;
    }

    this.getDynamicFormTemplateFilter();
    this.DocumentDropdown('CLIENT');

  }
  //.................................................editTemplate..............................................
  editTemplate(data) {
    this.clearFileInput();
    this.DocumentDropdown(data.entityTypeCode);
    this.saveBo = data;
    this.saveBo.documentName = data.filePath;
    this.saveBo.groupNameLid = data.groupNameLid?.toString();
    this.FileURl = null;
    this.name = data.name;
    this.entityTypeCode = data.entityTypeCode;
    this.dynamicFormTemplateId = data.id;
    this.getDynamicFormTemplateConfiguration(data.id);
    this.getDynamicFormTemplateDataDictionary(data.entityTypeCode);
    //this.generateDynamicForm(data.id);
    this.selectedFormFields = [];

  }
  //.................................................onActionComplete..............................................
  public onActionComplete(args) {
    this.GetDynamicFormTemplateList.currentpageno =
      this.gridDynamicFormTemplate.pagerModule.pagerObj.currentPage;
    this.GetDynamicFormTemplateList.pageitem =
      this.gridDynamicFormTemplate.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.GetDynamicFormTemplateList.type = args.columnType;
    }
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridDynamicFormTemplate.columns.forEach((element) => {
        if (
          element.visible == false &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          hidearr.push(element.headerText);
        }
        if (
          element.visible == true &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          showarr.push(element.headerText);
        }
      });
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].Dynamic_Form_Template.ShowColumns.forEach((old) => {
          showarr.forEach((element) => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].Dynamic_Form_Template.HideColumns.forEach((old) => {
          hidearr.forEach((element) => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (
          this.arraycol[0].Dynamic_Form_Template.ShowColumns.length != count1 ||
          this.arraycol[0].Dynamic_Form_Template.HideColumns.length != count
        ) {
          this.arraycol[0].Dynamic_Form_Template.ShowColumns = showarr;
          this.arraycol[0].Dynamic_Form_Template.HideColumns = hidearr;
          this.SaveColumnwidth();
        }
      }
    }
  }
  public dataStateChange(DFT): void {
    let val = DFT.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((DFT.sorted || []).length) {
        this.GetDynamicFormTemplateList.orderColumn = DFT.sorted[0].name;
        this.GetDynamicFormTemplateList.orderType =
          DFT.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && DFT.action.action != "clearFilter") {
      this.GetDynamicFormTemplateList.field =
        DFT.action.currentFilterObject.field;
      this.GetDynamicFormTemplateList.matchCase =
        DFT.action.currentFilterObject.matchCase;
      this.GetDynamicFormTemplateList.operator =
        DFT.action.currentFilterObject.operator;
      this.GetDynamicFormTemplateList.value =
        DFT.action.currentFilterObject.value;
    } else {
      if (val == "filtering" && DFT.action.action == "clearFilter") {
        this.GetDynamicFormTemplateList.type = "name";
        this.GetDynamicFormTemplateList.field = "name";
        this.GetDynamicFormTemplateList.operator = "contains";
        this.GetDynamicFormTemplateList.value = "";
        this.GetDynamicFormTemplateList.matchCase = false;
      }
    }
    if (val == "paging" && DFT.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Dynamic_Form_Template.Pagesize != DFT.take) {
          this.arraycol[0].Dynamic_Form_Template.Pagesize = DFT.take;
          this.SaveColumnwidth();
        }
      }
    }
    this.getDynamicFormTemplateFilter();
  }
  //.................................................onResize..............................................
  onResize(args) {
    if (this.ColumnArray != null && this.ColumnArray != undefined) {
      const column = this.gridDynamicFormTemplate.getColumnByField(
        args.column.field
      );
      column.width = args.column.width;
      this.ColumnArray.forEach((element) => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      this.SaveColumnwidth();
    }
  }
  //.................................................SaveColumnwidth..............................................
  SaveColumnwidth() {
    this.arraycol[0].Dynamic_Form_Template.Columns = this.ColumnArray;
    this.columnchange.agencyId = parseInt(this.global.globalAgencyId);
    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.DFTS.Savewidth(this.columnchange,)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.getColumnwidth();
      });
  }
  //.................................................getColumnwidth..............................................
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].Dynamic_Form_Template.Columns;
    let showcol = this.arraycol[0].Dynamic_Form_Template.ShowColumns;
    let hidecol = this.arraycol[0].Dynamic_Form_Template.HideColumns;
    this.gridDynamicFormTemplate.showColumns(showcol);
    this.gridDynamicFormTemplate.hideColumns(hidecol);
    if (
      this.global.globalColumn.userid != null &&
      this.global.globalColumn.agencyId != null
    ) {
      this.id = this.global.globalColumn.id;
    }
    if (this.gridDynamicFormTemplate != undefined) {
      this.ColumnArray.forEach((element) => {
        if (element.column == "Name") {
          const column = this.gridDynamicFormTemplate.getColumnByField("name");
          column.width = element.width;
          this.gridDynamicFormTemplate.refreshHeader();
        }
        if (element.column == "Entity TypeCode") {
          const column =
            this.gridDynamicFormTemplate.getColumnByField("entityTypeCode");
          column.width = element.width;
          this.gridDynamicFormTemplate.refreshHeader();
        }
        if (element.column == "Actions") {
          const column = this.gridDynamicFormTemplate.getColumnByUid("action");
          column.headerText = "Actions";
          column.width = element.width;
          this.gridDynamicFormTemplate.refreshHeader();
        }
      });
    }
  }
  //..............................................................showDFT.................................................
  showDFT() {
    this.gridDynamicFormTemplate.columnChooserModule.openColumnChooser(200, 50);
  }
  //.................................................getDynamicFormTemplateFilter..............................................
  getDynamicFormTemplateFilter() {
    if (this.FilterselectedType != null && this.FilterselectedType != undefined && this.FilterselectedType != '') {
      this.GetDynamicFormTemplateList.groupNameLid = (this.FilterGroupType != null && this.FilterGroupType != undefined && this.FilterGroupType != '') ? this.FilterGroupType : null;
    }
    else {
      this.FilterGroupType = null;
      this.GetDynamicFormTemplateList.groupNameLid = this.FilterGroupType;
    }
    this.GetDynamicFormTemplateList.agencyId =
      this.global.globalAgencyId != null &&
        this.global.globalAgencyId != undefined &&
        this.global.globalAgencyId != ""
        ? this.global.globalAgencyId
        : null;
    this.GetDynamicFormTemplateList.entityTypeCode = this.FilterselectedType;
    this.DFTS.outputValues(this.GetDynamicFormTemplateList);
    let count = 0;
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        if (data.result.length > 15) {
          this.gridDynamicFormTemplate.height = "500";
        } else {
          this.gridDynamicFormTemplate.height = "auto";
        }
        if (data != null && data != undefined && count == 1) {
          this.getColumnwidth();
        }
      }
    );
  }

  getDynamicFormTemplateFilter1() {
    if (this.FilterselectedType != null && this.FilterselectedType != undefined && this.FilterselectedType != '') {
      this.GetDynamicFormTemplateList.groupNameLid = (this.FilterGroupType != null && this.FilterGroupType != undefined && this.FilterGroupType != '') ? this.FilterGroupType : null;
    }
    else {
      this.FilterGroupType = null;
      this.GetDynamicFormTemplateList.groupNameLid = this.FilterGroupType;
    }
    this.GetDynamicFormTemplateList.agencyId =
      this.global.globalAgencyId != null &&
        this.global.globalAgencyId != undefined &&
        this.global.globalAgencyId != ""
        ? this.global.globalAgencyId
        : null;
    this.GetDynamicFormTemplateList.entityTypeCode = this.FilterselectedType;
    let url = "api/DynamicForm/getDynamicFormTemplates"
    let responseData =
    {
      count: "count",
      result: "result",
    }
    this.CommonAPI.outputValues(url, this.GetDynamicFormTemplateList, responseData, "");
    let count = 0;
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        if (data.result.length > 15) {
          this.gridDynamicFormTemplate.height = "500";
        } else {
          this.gridDynamicFormTemplate.height = "auto";
        }
        if (data != null && data != undefined && count == 1) {
          this.getColumnwidth();
        }
      }
    );
  }
  //................................................onFileUpload....................................
  onFileUpload(fileInput: any) {
    if (fileInput.target.files.length > 0) {
      this.TemplateFile = <File>fileInput.target.files[0];
      this.saveBo.documentName = ''; // Clear the document name
      this.updateLabelText();
      this.saveBo.documentName = this.TemplateFile.name;
      this.saveBo.documentType = this.TemplateFile.type;

      if (this.saveBo.documentType == "application/pdf") {
        this.validatingFile = false;
      } else {
        this.validatingFile = true;
        this.toasterService.error("");
      }
    }
  }
  //................................................clearModal....................................
  clearModal() {
    this.validatingFile = false;
    this.saveBo = new saveTemplateBo();
    // this.saveBo.entityTypeCode = this.dynamicFormTemplateType?.filter(
    //   (s) => s.typeName == "SESSION"
    // )[0]?.id;
  }
  //................................................SaveTemplate...........................................
  uploadDynamicFormTemplate() {
    this.isSaveorUpdateBoolean=true;
    let AgencyId =
      this.global.globalAgencyId != null &&
        this.global.globalAgencyId != null &&
        this.global.globalAgencyId != ""
        ? this.global.globalAgencyId
        : "";
    if (this.saveBo.id == null || this.saveBo.id == undefined || this.saveBo.id == '') {
      this.saveBo.id = '00000000-0000-0000-0000-000000000000'
    }
    let Formdata = new FormData();
    Formdata.append("id", this.saveBo.id)
    Formdata.append("entityTypeCode", this.saveBo.entityTypeCode);
    Formdata.append("name", this.saveBo.name);
    Formdata.append("template", this.TemplateFile);
    Formdata.append("agencyId", AgencyId);
    Formdata.append("groupNameLid", this.saveBo.groupNameLid);
    this.DFTS
      .uploadDynamicFormTemplate(Formdata)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.isSaveorUpdateBoolean=false;
          if (this.saveBo.id == null || this.saveBo.id == undefined || this.saveBo.id == '') {
            this.toasterService.success("Template saved successfully");
          }
          else {
            this.toasterService.success("Template updated successfully");
          }
          document.getElementById("OpneSaveModal").click();
          this.clearModal();
          this.getDynamicFormTemplateFilter();
        },
        (err: any) => {
          this.isSaveorUpdateBoolean=false;
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }
  //................................................getDynamicFormTemplateConfiguration...........................................
  getDynamicFormTemplateConfiguration(id) {
    let params = new URLSearchParams();
    params.append("dynamicFormTemplateId", id);
    this.DFTS
      .getDynamicFormTemplateConfiguration(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.FormFieldList = data.formFields;
      });
  }
  //................................................getDynamicFormTemplateDownloadUrl...........................................
  getDynamicFormTemplateDownloadUrl(id) {
    let params = new URLSearchParams();
    params.append("dynamicFormTemplateId", id);
    this.DFTS
      .getDynamicFormTemplateDownloadUrl(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        console.log(data);
        const a = document.createElement("a");
        a.href = data;
        a.click();
      });
  }

  //................................................getDynamicFormTemplateDataDictionary...........................................
  getDynamicFormTemplateDataDictionary(name) {
    let params = new URLSearchParams();
    params.append("entityTypeCode", name);
    this.DFTS
      .getDynamicFormDataDictionary(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.DynamicFormTemplateDataDictionary = data;
      });
  }
  // ...........................................bindValues.................................................
  bindValues() {
    if (this.selectedFormFields.length > 0) {
      this.FormFieldList?.forEach((element) => {
        let assignFields = this.selectedFormFields[0];
        if (element.formFieldName == assignFields.formFieldName) {
          element.id = assignFields.id;
          element.formFieldName = assignFields?.formFieldName;
          element.dynamicFormDataDictionaryId =
            assignFields.dynamicFormDataDictionaryId;
          element.defaultValue = assignFields.defaultValue;
        }
      });
    }
    this.configuredynamicFormTemplate();
  }
  // ...........................................configuredynamicFormTemplate.................................................
  configuredynamicFormTemplate() {
    let payload = {
      entityTypeCode: this.entityTypeCode,
      dynamicFormTemplateId: this.dynamicFormTemplateId,
      name: this.name,
      formFields: this.FormFieldList,
    };

    this.DFTS
      .configureDynamicFormTemplate(payload)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          document.getElementById("openTemplatemodal").click();
          this.toasterService.success("Configured successfully!");
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        },
        (err: HttpErrorResponse) => {
          this.toasterService.error(err.error, " Error");
          setTimeout(() => {
            this.toasterService.clear();
          }, 2000);
        }
      );
  }
  // ...........................................getSpecificFormField.................................................
  async getSpecificFormField(findController: PointerEvent) {
    const target = findController.target as HTMLInputElement;

    // findController.target?.addEventListener('input', function (event) {

    //   const target = event.target as HTMLInputElement;

    // });

    // const rawFormField = await this.ngxService.getFormData(true);
    // let formfield = rawFormField.map((annotation: any) => ({
    //   alternativeText: annotation.fieldAnnotation.alternativeText,
    //   fieldName: annotation.fieldAnnotation.fieldName,
    //   fieldType: annotation.fieldAnnotation.fieldType,
    //   fieldValue: annotation.fieldAnnotation.fieldValue,
    //   value: annotation.fieldAnnotation.value,
    //   id: annotation.fieldAnnotation.id,
    //   maxLen: annotation.fieldAnnotation.maxLen,
    //   rect: annotation.fieldAnnotation.rect,
    // }));

    if (target.name != null && target.name != undefined && target.name != "") {
      this.selectedFormFields = [];
      this.FormFieldList.forEach((element) => {
        if (element.formFieldName == target.name) {
          this.selectedFormFields.push(element);
        }
      });
    } else {
      this.selectedFormFields = [];
    }
  }
  // ...........................................generateDynamicForm.................................................
  generateDynamicForm(Id) {
    this.closeModeltemplate();
    let params = new URLSearchParams();
    params.append("templateId", Id);
    this.DFTS
      .generateDynamicTemplate(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          let file = new Blob([data], { type: "application/pdf" });
          this.FileURl = file;
          console.log(this.FileURl);
        },
        (err: any) => {
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }
  //...................................................deletemonitor..................................
  deleteTemplate(id) {
    this.DynamicTemplateId = id;
    document.getElementById('TemplateDropdeleteModal').click();
  }
  //...................................................deletemonitorlist..................................
  DeleteFunction() {
    let params = new URLSearchParams();
    params.append("dynamicFormTemplateId", this.DynamicTemplateId?.toString());

    this.DFTS.DeleteFunctionForDeleteHttp(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toasterService.success("Dynamic Template deleted successfully!");
          document.getElementById('TemplateDropdeleteModal').click();
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
          this.getDynamicFormTemplateFilter();
        },
        (err: any) => {
          this.toasterService.error(err);
        }
      );
  }
  closeTemplate() {
    document.getElementById('TemplateDropdeleteModal').click();
  }
  ///////////////////////////////////////////////////////////////////////////
  filepermissionget() {
    // let params = new URLSearchParams();
    // let url = "api/functionpermisssion/getfunctionpermission?";
    // params.append("pagecode", "DynamicFormTemplate");
    // params.append("roleId", this.global.roleId);
    // this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    //   if (data != null) {
    //     this.fp = data;
    //   }
    //   else {
    //     this.fp = new functionpermission();
    //   }
    // },
    //   (err: HttpErrorResponse) => {
    //     this.fp = new functionpermission();
    //   })
  }
  updateLabelText() {
    this.labelText = this.saveBo.documentName || 'Choose file';
  }
  labelText: string = '';

  clearFileInput() {
    // This will clear the file name from the input
    this.fileInput.nativeElement.value = '';
  }
  AddnewTemplate() {
    this.saveBo = new saveTemplateBo();
    this.saveBo.documentName = "";
    this.clearFileInput();
  }
  closeViewPdf() {
    document.getElementById("openTemplatemodal").click();
  }


  closeModeltemplate() {

    document.getElementById("OpneSaveModal").click();
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  clearlov() {
    this.Lov = new LovBO();
    document.getElementById("GroupNameLovopen").click();
    this.DocumentDropdown(this.FilterselectedType);

  }
  saveLov(listParam) {
    let val = listParam.lovName.replace(/\s/g, "");
    let url = "api/LOV/SaveLov";
    console.log(this.saveBo.entityTypeCode, listParam)
    if (this.saveBo.entityTypeCode == 'CLIENT') {
      var obj = {
        ListId: this.listId,
        Id: listParam.Id,
        lovCode: val.toUpperCase(),
        lovName: listParam.lovName,
        lovValue: null,
        orderby: 0,
      }
    }
    else if (this.saveBo.entityTypeCode == 'EMPLOYEE') {
      var obj = {
        ListId: this.listId,
        Id: listParam.Id,
        lovCode: val.toUpperCase(),
        lovName: listParam.lovName,
        lovValue: null,
        orderby: 0,

      }    

    } else{
      this.toasterService.error("Please Select Type");
      return;
    }
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(obj, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.DocumentDropdown(this.saveBo.entityTypeCode);
      this.clearlov();
      this.toasterService.success("Group saved successfully");
    },
      (err: any) => {
        this.toasterService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toasterService.clear()
        }, 8000);

      })
  }
  DocumentDropdown(value) {
    console.log(value, "value")
    let params = new URLSearchParams();
    if (value == 'CLIENT') {
      params.append("ListCode", "DYNAMICTEMPLATECLIENTONBOARDGROUP");
    }
    else if (value == 'EMPLOYEE') {
      params.append("ListCode", "DYNAMICTEMPLATEEMPLOYEEONBOARDGROUP");
    };
    let url = "api/LOV/GetLovDropDown?";
    // params.append("ListCode", this.global.userID);
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.GroupNameList = data;
      this.GroupNameList.forEach((element) => {
        this.listId = element.listId;
        element.id = element.id;
        element.lovName = element.lovName;
      })
      console.log(this.GroupNameList, "GroupNameList")
    })
  }
}
